import React, { useState, useEffect, useRef } from "react";
import { Grid } from "@mui/material";
import Sets from "./Sets";
import TitleBar from "../general/TitleBar";
import LoadingBackdrop from "../general/LoadingBackdrop";

const competitionContainerStyle = {
  backgroundColor: "#F3F0F4",
  borderRadius: "0 0 12px 12px",
  padding: 32,
};

export default function ConfigureTeamCompetitonSection({ competition }) {
  const isMounted = useRef(false);
  const [expandUp, setExpandUp] = useState(true);
  const [expandLs, setExpandLs] = useState(true);
  const [expandUs, setExpandUs] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    isMounted.current = true;
    return () => (isMounted.current = false);
  }, []);

  return (
    <Grid container>
      <LoadingBackdrop loading={loading} />
      <TitleBar
        title="Upper Primary Division"
        state={expandUp}
        setState={setExpandUp}
        main
      />
      {expandUp && (
        <Grid container style={competitionContainerStyle}>
          <Sets
            division="UP"
            setsData={competition?.data?.question_sets.filter(
              (qSet) => qSet?.division.toLowerCase() === "up"
            )}
          />
        </Grid>
      )}
      <TitleBar
        title="Lower Secondary Division"
        state={expandLs}
        setState={setExpandLs}
        main
      />
      {expandLs && (
        <Grid container style={competitionContainerStyle}>
          <Sets
            division="LS"
            setsData={competition?.data?.question_sets.filter(
              (qSet) => qSet?.division.toLowerCase() === "ls"
            )}
          />
        </Grid>
      )}
      <TitleBar
        title="Upper Secondary Division"
        state={expandUs}
        setState={setExpandUs}
        main
      />
      {expandUs && (
        <Grid container style={competitionContainerStyle}>
          <Sets
            division="US"
            setsData={competition?.data?.question_sets.filter(
              (qSet) => qSet?.division.toLowerCase() === "us"
            )}
          />
        </Grid>
      )}
    </Grid>
  );
}
